<div class="wrap-popup">
  <div class="header">
    <img class="pointer" (click)="close()" src="assets\images\close.svg">
  </div>

  <div class="body">
    <p class="warning" translate>column.approvals.exportPayrollConfirmWarning</p>
    <p class="total" *ngIf="data.count != null" translate [translateParams]="{ count: data.count }">column.approvals.exportPayrollConfirmTotal</p>
  </div>

  <div>
    <div class="divider"></div>
  </div>

  <div class="footer">
    <div class="btns">
      <button type="button" class="cancel pointer" (click)="close()">
        <p translate>header.viewAnswers.cancel</p>
      </button>

      <button type="button" class="save pointer" (click)="confirm()">
        <p translate>column.approvals.exportPayrollConfirmButton</p>
      </button>
    </div>
  </div>
</div>
